import Splide from '@splidejs/splide';

const stepsSlider = document.querySelector('.steps .splide');
if (stepsSlider) {
  const steps = new Splide(stepsSlider, {
    type: 'slide',
    arrows: false,
    pagination: true,
    breakpoints: {
      580: {
        arrows: true,
      },
      1440: {
        pagination: false,
        isNavigation: true,
        autoWidth: true,
      },
    },
  });

  steps.on('pagination:mounted', (data) => {
    data.list.classList.add('splide__pagination--custom');
    data.items.forEach((item) => {
      // eslint-disable-next-line no-param-reassign
      item.button.textContent = String(item.page + 1);
    });
  });

  steps.mount();
}
